<template>
  <div class="u-content">
    <page-nav :nav-list="navList" />
    <div class="touch-wrap clearfix">
      <div class="touch-left">
        <span>联系我们</span>
        <ul class="sub-menu">
          <li
            v-for="{id, code, name} in type"
            :key="id"
            class="current"
            :class="{'active': typeCode === code}"
            @click="changeTypeCode(code, name)">
            {{ name }}
          </li>
        </ul>
      </div>
      <div class="touch-right">
        <span class="title"><b>{{ typeName }}</b></span>
        <div v-if="typeCode === '001'" class="us-con-main">
          <p v-for="{id, content} in detail" :key="id" class="one-line">{{ content }}</p>
        </div>
        <div v-if="typeCode === '002'" class="us-con-main">
          <p class="us-title">工业和信息化部人才交流中心</p>
          <p class="us-left">地址：北京市海淀区万寿路27号院</p>
          <p class="us-left">
            <span class="us-email">电话：010-68207839</span>
            <span class="us-email">邮编：100846</span>
          </p>
          <p class="us-left">信箱：gxrc@miitec.cn</p>
          <p class="us-left">网址：http://www.miitec.cn/</p>
          <p class="table-title">咨询电话一览表</p>
          <table border="1" class="tel-table">
            <tr v-for="{id, firstLine, secondLine} in tableData" :key="id">
              <th class="table-first">{{ firstLine }}</th>
              <th class="table-second">{{ secondLine }}</th>
            </tr>
          </table>
        </div>
        <div v-if="typeCode === '003'" class="us-con-main">
          <p class="one-line">地铁线路：地铁1号线万寿路站下C口出</p>
          <template>
            <div>
              <baidu-map
                class="map"
                :center="map.center"
                ak="vmiOzgewN9L2Wn0jmKYZ9q3Qh4PYGyEH"
                :zoom="map.zoom"
                @ready="handler">
                <!--缩放-->
                <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT" />
                <!--点-->
                <bm-marker
                  :position="map.center"
                  :dragging="map.dragging"
                  animation="BMAP_ANIMATION_DROP">
                  <!--提示信息-->
                  <bm-info-window :show="map.show">
                    <p>人才交流中心</p>
                    <p>工业和信息化部</p>
                  </bm-info-window>
                </bm-marker>
              </baidu-map>
            </div>
          </template>
        </div>
        <div v-if="typeCode === '004'" class="us-con-main">
          <p class="supervise-title">欢迎您访问作风建设监督栏目！您对人才交流中心工作意见和建议，可通过以下方式联系我们。</p>
          <p class="supervise-contact-mode">作风建设监督邮箱：zfjd@miitec.cn</p>
          <p class="supervise-contact-mode">作风建设监督电话：010-68207836</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageNav from '@/components/pageNav'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmNavigation from 'vue-baidu-map/components/controls/Navigation.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow.vue'
import wordData from './data.js'

export default {
  components: {
    PageNav,
    BaiduMap,
    BmNavigation,
    BmMarker,
    BmInfoWindow
  },
  data() {
    return {
      navList: ['联系我们'],
      detail: null,
      type: null,
      typeCode: '',
      typeName: '',
      tableData: null,
      map: {
        center: { lng: 116.302450, lat: 39.910733 },
        zoom: 15,
        show: true,
        dragging: true
      }
    }
  },
  mounted() {
    this.detail = wordData.detail
    this.type = wordData.type
    this.typeCode = this.type[0].code
    this.typeName = this.type[0].name
    this.tableData = wordData.tableData
  },
  methods: {
    changeTypeCode(code, name) {
      this.typeCode = code
      this.typeName = name
    },
    handler({ BMap, map }) {
      map.enableScrollWheelZoom(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .u-content{
    padding: 0 10px;
    .touch-wrap{
      margin: 20px 0px;
      .touch-left{
        width: 20%;
        float: left;
        span{
          display: inline-block;
          width: 100%;
          height: 50px;
          font-size: 18px;
          font-weight: bold;
          line-height: 50px;
          text-align: center;
          color: rgb(255, 255, 255);
          background: rgb(155, 24, 30);
        }
        .sub-menu{
          width: 100%;
          background: rgb(244, 244, 244);
          padding: 10px 0px;
          li{
            font-size: 16px;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
            &:hover{
              background: rgb(249, 233, 233);
            }
            &.active{
              background: rgb(249, 233, 233);
            }
          }
        }
      }
      .touch-right{
        width: 78%;
        float: right;
        .title{
          display: inline-block;
          height: 30px;
          line-height: 30px;
          font-size: 16px;
          border-bottom: 1px solid #ccc;
          width: 100%;
          b{
            border-bottom: 2px solid #9B181E;
            display: inline-block;
          }
        }
        .us-con-main{
          width: 900px;
          padding-bottom:80px;
          min-height: 400px;
          .one-line{
            margin-top: 20px;
            line-height: 24px;
          }
          .us-title{
            font-size: 30px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            margin-top: 20px;
          }
          .us-left{
            margin-top: 20px;
            line-height: 24px;
            padding-left: 280px;
            .us-email{
              margin-right: 60px;
            }
          }
          .table-title{
            font-size: 20px;
            text-align: center;
            margin-top: 20px;
          }
          .tel-table{
            margin: 10px auto;
            .table-first{
              width: 214px;
              text-align: center;
            }
            .table-second{
              width: 314px;
              text-align: center;
            }
          }
          .supervise-title{
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            margin: 20px 0 35px;
          }
          .supervise-contact-mode{
            margin-top: 20px;
            margin-left: 60px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .map {
    width: 100%;
    height: 400px;
  }
</style>
